import React from 'react';
import { Chat } from '@base/features/chat/chat';

const GameChatLayout = () => {
  return (
    <div className="game-sidebar__chat">
      <Chat />
    </div>
  );
};

export default GameChatLayout;
